/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { DidCommMessageBlobAttachmentStatus } from './DidCommMessageBlobAttachmentStatus';

export const DidCommMessageBlobStatus: core.serialization.ObjectSchema<
    serializers.DidCommMessageBlobStatus.Raw,
    Truvity.DidCommMessageBlobStatus
> = core.serialization.object({
    attachments: core.serialization.list(DidCommMessageBlobAttachmentStatus),
    blobId: core.serialization.property('blob_id', core.serialization.string()),
    errorMessage: core.serialization.property('error_message', core.serialization.string().optional()),
    id: core.serialization.string(),
    status: core.serialization.string(),
});

export declare namespace DidCommMessageBlobStatus {
    export interface Raw {
        attachments: DidCommMessageBlobAttachmentStatus.Raw[];
        blob_id: string;
        error_message?: string | null;
        id: string;
        status: string;
    }
}
